import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import ReviewItemModel from 'donor-elf-web/models/review-item';

export default class ReviewItemsController extends Controller {
  declare model: ReviewItemModel[];

  @tracked items: ReviewItemModel[] = [];

  @action
  templateDidInsert() {
    this.items = this.model.slice();
  }

  @action
  handleSave(reviewItem: ReviewItemModel) {
    setTimeout(() => {
      this.items = this.items.filter((x) => x.id !== reviewItem.id);
    }, 1000);
  }
}
